import { render, staticRenderFns } from "./game.vue?vue&type=template&id=147395f2&scoped=true"
var script = {}
import style0 from "./game.vue?vue&type=style&index=0&id=147395f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147395f2",
  null
  
)

export default component.exports